module.exports = __webpack_public_path__ + "static/img/mask-01-01.45e87f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/mask-01-01.jpg
// module id = 275
// module chunks = 1